import { FieldCellMixins } from './mixins.js';

const RatingCell = {
  mixins: [FieldCellMixins],

  template: `
    <div class="rating-list secondary">
      <div v-for='number in value' class="rating-item active">
        <i class="slp-star"></i>
      </div>
    </div>
  `,

  computed: {
    value: function() {
      return parseInt(this.entries[0]?.value) || 0;
    }
  }
};

export { RatingCell };
